import { useState, useEffect } from 'react';
import { ArrowLeft, Pencil, ExternalLink } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CmsVisuels({ navigate }) {
  const [tab, setTab] = useState('accueil');
  const [visuels, setVisuels] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editUrl, setEditUrl] = useState('');

  const load = () => fetch(`${API}/api/site/visuels`).then(r => r.json()).then(setVisuels).catch(() => {});
  useEffect(() => { load(); }, []);

  const filtered = visuels.filter(v => v.page === tab);

  const handleSave = async (id) => {
    await fetch(`${API}/api/site/visuels/${id}`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: editUrl })
    });
    setEditingId(null);
    load();
  };

  const tabs = [
    { id: 'accueil', label: "Page d'accueil" },
    { id: 'restaurant', label: 'Restaurant' },
    { id: 'traiteur', label: 'Traiteur' },
  ];

  const getImgSrc = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${API}${url}`;
  };

  return (
    <div data-testid="cms-visuels">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('dashboard')} className="flex items-center gap-2 text-gray-500 hover:text-gray-700 text-sm" data-testid="visuels-back-btn">
            <ArrowLeft size={16} /> Retour
          </button>
          <div className="flex items-center gap-2">
            <span className="text-gray-300">|</span>
            <h1 className="text-lg font-bold text-gray-900">Visuels du site</h1>
          </div>
        </div>
        <a href="/site/restaurant" target="_blank" rel="noreferrer"
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
          <ExternalLink size={14} /> Voir le site
        </a>
      </div>

      {/* Tab toggle */}
      <div className="flex rounded-lg overflow-hidden border border-gray-200 mb-6 w-fit">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`px-5 py-2 text-sm font-medium transition-colors ${tab === t.id ? 'bg-[#1a2744] text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
            data-testid={`visuels-tab-${t.id}`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Visuels grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {filtered.map(v => (
          <div key={v.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-testid={`visuel-${v.id}`}>
            <div className="relative aspect-video bg-gray-100">
              {v.url ? (
                <img src={getImgSrc(v.url)} alt={v.label} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-gray-300">
                  <Pencil size={32} />
                </div>
              )}
              <button
                onClick={() => { setEditingId(v.id); setEditUrl(v.url || ''); }}
                className="absolute top-2 right-2 bg-white/90 hover:bg-white p-2 rounded-lg shadow-sm"
                data-testid={`edit-visuel-${v.id}`}>
                <Pencil size={14} className="text-gray-600" />
              </button>
            </div>
            <div className="p-3">
              <p className="font-medium text-sm text-gray-900">{v.label}</p>
              <p className="text-xs text-gray-400 truncate">{v.url || 'Non defini'}</p>
            </div>

            {editingId === v.id && (
              <div className="p-3 pt-0 space-y-2">
                <input type="text" value={editUrl} onChange={e => setEditUrl(e.target.value)}
                  placeholder="URL de l'image" className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
                  data-testid={`visuel-url-input-${v.id}`} />
                <div className="flex gap-2">
                  <button onClick={() => handleSave(v.id)}
                    className="bg-[#1a2744] text-white px-3 py-1.5 rounded-lg text-xs font-medium" data-testid={`save-visuel-${v.id}`}>
                    Enregistrer
                  </button>
                  <button onClick={() => setEditingId(null)} className="text-xs text-gray-500">Annuler</button>
                </div>
              </div>
            )}
          </div>
        ))}
        {filtered.length === 0 && <p className="text-sm text-gray-400 col-span-3 text-center py-12">Aucun visuel pour cette section</p>}
      </div>
    </div>
  );
}
